// extracted by mini-css-extract-plugin
export var fancyLists = "Wysiwyg-module--fancy-lists--8f7b3";
export var wysiwyg = "Wysiwyg-module--wysiwyg--cb696";